import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { categoryQueries } from '../queries/category-queries.js';
import { deleteCategory } from '../requests/delete-category.js';

export const useDeleteCategoryMutation = (): UseMutationResult<void, Error, string> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCategory,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: categoryQueries.lists() }),
  });
};
